import {BaseRouteConfig} from "../../../core/components/router/models/base-route-config";
import {ROUTE_NAMES, ROUTE_TYPES} from "../../../core/consts";
import {ReactLazyPreload} from "../../../core/components/router/react-lazy-preload";
import {CompetitorMatchModel} from "./competitor.match-model";

export class CompetitorPageRouteConfig extends BaseRouteConfig {
  static injectables = [];

  constructor({name, path, componentImport, metadataType, matchType}) {
    super();

    this.name = name;
    this.path = path;
    this.parentPath = path ? `/:sportName/team/:key/${path}` : null;
    this.component = ReactLazyPreload(componentImport);
    this.metadataType = metadataType;
    this.matchType = matchType || CompetitorMatchModel;
    this.parent = ROUTE_NAMES.competitor;
    this.routeType = ROUTE_TYPES.nested;
  }
}
